// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"147":"7e7ce0f0","254":"78065e70","375":"01c8cf76","391":"b5b08b84"}[chunkId] + ".chunk.js";
};